import React, { useState, useRef } from "react";
import { AppBar, Toolbar, MenuItem, ClickAwayListener, Box, Typography, alpha, Button, IconButton, Drawer, List, ListItem, ListItemText, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
// import MenuIcon  from "@mui/icons-material/Menu"; // Import the Menu icon
import logo from "../images/logo.png"; // Import the logo
import {
  Menu as MenuIcon,
  ArrowDropDown as ArrowDropDownIcon
} from "@mui/icons-material";
import FeaturesMenu from "./FeaturesMenu";

const AppToolbar = () => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false); // State for the Drawer
  
  // Toggle Drawer function
  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setDrawerOpen(open);
  };

  const [featuresMenuOpen, setFeaturesMenuOpen] = useState(false);
  const featuresAnchorRef = useRef(null);

  const handleFeaturesEnter = () => {
    setFeaturesMenuOpen(true);
  };

  const handleFeaturesLeave = () => {
    setFeaturesMenuOpen(false);
  };



  const handleFeaturesClick = () => {
    setFeaturesMenuOpen((prev) => !prev);
  };

  const handleFeaturesClose = () => {
    setFeaturesMenuOpen(false);
  };

  const handleMenuClose = () => {
    setFeaturesMenuOpen(false);
  };

  


  return (
    <ClickAwayListener onClickAway={handleFeaturesClose}>
    <Box sx={{ position: 'relative' }}>

    <AppBar
      position="static"
      sx={{
        backgroundColor: "#fff", // Custom background color
        color: "#000", // Custom text color
        px: 0,
      }}
      elevation={0}
    >
      <Toolbar>
        <Box
          component="img"
          src={logo}
          alt="FreshSweeper Logo"
          sx={{ height: 30, marginRight: 2 }}
        />

        {/* Title */}
        <Typography
          style={{ fontWeight: 700, fontSize: 26 }}
          variant="h6"
          component="div"
          sx={{ flexGrow: 1 }}
        >
          Freshsweeper
        </Typography>

        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 3, alignItems: "center" }}>
              <Button component={Link} to="/" color="inherit" sx={{ color: theme.palette.text.primary, fontWeight: 500, fontSize: "0.95rem" }}>Home</Button>
              <Button component={Link} to="/pricing" color="inherit" sx={{ color: theme.palette.text.primary, fontWeight: 500, fontSize: "0.95rem" }}>Pricing</Button>
              
              {/* Features Dropdown */}
            <Button 
              color="inherit" 
              ref={featuresAnchorRef}
              onMouseEnter={handleFeaturesEnter}
              endIcon={<ArrowDropDownIcon />}
              sx={{ 
                color: theme.palette.text.primary, 
                fontWeight: 500, 
                fontSize: "0.95rem",
                background: featuresMenuOpen ? alpha(theme.palette.primary.main, 0.1) : 'transparent'
              }}
            >
              Features
            </Button>

              <Button component={Link} to="/cleaner" color="inherit" sx={{ color: theme.palette.text.primary, fontWeight: 500, fontSize: "0.95rem" }}>For Cleaners</Button>
              <Button 
                variant="contained" 
                sx={{ 
                  background: theme.palette.primary.main,
                  borderRadius: "6px",
                  px: 2.5,
                  fontSize: "0.95rem",
                  fontWeight: 600,
                  boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`
                }}
              >
                Get the App
              </Button>
            </Box>

        {/* Desktop Buttons (hidden on small screens) */}
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          {/* <Button color="inherit" component={Link} to="/">
            Home
          </Button> */}
          {/* <Button color="inherit" component={Link} to="/contact">
            Contact Us
          </Button>
          <Button color="inherit" component={Link} to="/privacyp">
            Privacy Policy
          </Button> */}
        </Box>

        {/* Mobile Menu Icon */}
        <IconButton
          sx={{ display: { xs: "block", sm: "none" } }}
          color="inherit"
          edge="end"
          onClick={toggleDrawer(true)}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Features Mega Menu */}
      <Box
        ref={featuresAnchorRef}
        onMouseLeave={handleFeaturesLeave}
        sx={{ position: 'relative' }}
      >
        {/* <FeaturesMenu
          open={featuresMenuOpen}
          anchorEl={featuresAnchorRef.current}
          onClose={handleFeaturesLeave}
        /> */}
        <FeaturesMenu
          open={featuresMenuOpen}
          anchorEl={featuresAnchorRef.current}
          onClose={handleMenuClose}
        />
      </Box>

      {/* Drawer for Mobile */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
      >
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List>
            <ListItem button component={Link} to="/">
              <ListItemText primary="Home" />
            </ListItem>
            <ListItem button component={Link} to="/contact">
              <ListItemText primary="Contact" />
            </ListItem>
            <ListItem button component={Link} to="/privacyp">
              <ListItemText primary="Privacy Policy" />
            </ListItem>
          </List>
        </Box>

        
      </Drawer>
    </AppBar>
</Box>
</ClickAwayListener>

  );
};

export default AppToolbar;




